import React, { Component } from 'react'
import LocationsSvg from '../icons/LocationsSvg'
import { Link } from 'react-router-dom';

export class Card7 extends Component {
    render() {
        const { className, icon, title, info, mail, adress } = this.props;
        return (
            <div className={`${className} flex flex-col items-center gap-[14px] p-[0px_50px] max-[900px]:gap-[7px] max-[600px]:p-[0px_0px] `}>
                <span className='p-[20px] rounded-[50%] bg-[#f4f8fc] max-[500px]:p-[12px]'>
                    {icon}
                </span>

                <h5 className='font-[700] text-[22px] text-[#2e2f46] max-[900px]:text-[20px] max-[500px]:text-[18px]'>{title}</h5>

                <div>
                    {adress ? (
                        <Link to="https://www.google.com/maps/place/CELT+Colleges+Xetai+-+%C4%B0ngilis+dili+kurslari/@40.381794,49.866566,15z/data=!4m2!3m1!1s0x0:0xb923a92b9b1a3639?sa=X&ved=2ahUKEwjWzdCw75WBAxXtmWoFHdAMDeQQ_BJ6BAhJEAA&ved=2ahUKEwjWzdCw75WBAxXtmWoFHdAMDeQQ_BJ6BAhfEAg" target='__blank'
                            className='font-[500] text-[18px] text-[#555555] hover:text-[var(--orange)] max-[900px]:text-[16px] max-[500px]:text-[14px]'>{adress}</Link>

                    ) : null
                    }
                    {info ? (
                        <Link to={`tel:${info}`} target='__blank' className='font-[500] text-[18px] text-[#555555] hover:text-[var(--orange)] max-[900px]:text-[16px] max-[500px]:text-[14px]'>{info}</Link>
                    ) : null
                    }
                    {mail ? (
                        <Link to={`mailto:${mail}`} target='__blank' className='font-[500] text-[18px] text-[#555555] hover:text-[var(--orange)] max-[900px]:text-[16px] max-[500px]:text-[14px]'>{mail}</Link>
                    ) : null
                    }
                </div>

            </div >
        )
    }
}

export default Card7